import styled from "styled-components/macro";

/**
 * One named file in a list, with room for an icon in front of the name. Shared by the upload
 * box, where a client attaches and removes files, and by the read only lists on the review and
 * completed views. The error styling covers an upload that failed.
 */
export const AttachedListItem = styled.li`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: var(--juno-font-size-body-sm);
  line-height: 1.5;
  font-weight: ${(props) => (props.error ? "normal" : "bold")};
  color: ${(props) => (props.error ? "var(--juno-color-red)" : "var(--juno-color-text)")};
`;

export const AttachIcon = styled.div`
  padding-top: 3px;
  font-size: 14px;
  transform: ${(props) => (props.error ? "none" : "rotate(45deg)")};
  color: ${(props) => (props.error ? "var(--juno-color-red)" : "var(--juno-color-green)")};
  margin-right: 8px;
`;
